import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import type { ChartHistoryFilterType } from "@roman/shared/constants/predictionChart";

interface PredictionChartMenuProps {
  displayMode: ChartHistoryFilterType;
  setDisplayMode: (mode: ChartHistoryFilterType) => void;
}

export const PredictionChartMenu = ({ displayMode, setDisplayMode }: PredictionChartMenuProps) => {
  return (
    <ToggleGroup
      type="single"
      value={displayMode}
      onValueChange={(value) => value && setDisplayMode(value as ChartHistoryFilterType)}
      className="justify-center"
    >
      <ToggleGroupItem value="all" size="sm">
        すべて
      </ToggleGroupItem>
      <ToggleGroupItem value="1M" size="sm">
        1M
      </ToggleGroupItem>
      <ToggleGroupItem value="1W" size="sm">
        1W
      </ToggleGroupItem>
      <ToggleGroupItem value="1D" size="sm">
        1D
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
